package kpt.core.database

import androidx.room3.migration.Migration
import androidx.sqlite.SQLiteConnection
import androidx.sqlite.execSQL
import kotlin.Suppress

@Suppress(names = ["UNCHECKED_CAST", "DEPRECATION", "REDUNDANT_PROJECTION", "REMOVAL", "OPT_IN_USAGE_ERROR", "OPT_IN_USAGE", "MemberExtensionConflict", "CAN_BE_VAL"])
internal class AppDatabase_AutoMigration_7_8_Impl : Migration {
  public constructor() : super(7, 8)

  public override suspend fun migrate(connection: SQLiteConnection) {
    connection.execSQL("CREATE TABLE IF NOT EXISTS `banking_loans` (`id` TEXT NOT NULL, `name` TEXT NOT NULL, `kind` TEXT NOT NULL, `principal` REAL NOT NULL, `principalRemaining` REAL NOT NULL, `annualRatePercent` REAL NOT NULL, `tenureMonths` INTEGER NOT NULL, `monthsRemaining` INTEGER NOT NULL, `monthlyPayment` REAL NOT NULL, `nextDueDate` TEXT NOT NULL, `totalPaid` REAL NOT NULL, `createdAtMs` INTEGER NOT NULL, `updatedAtMs` INTEGER NOT NULL, PRIMARY KEY(`id`))")
    connection.execSQL("CREATE TABLE IF NOT EXISTS `banking_bill_reminders` (`id` TEXT NOT NULL, `name` TEXT NOT NULL, `amount` REAL NOT NULL, `dueDay` INTEGER NOT NULL, `recurrence` TEXT NOT NULL, `category` TEXT NOT NULL, `enabled` INTEGER NOT NULL, `reminderDaysBefore` INTEGER NOT NULL, `createdAtMs` INTEGER NOT NULL, `updatedAtMs` INTEGER NOT NULL, PRIMARY KEY(`id`))")
  }
}
